import { useEffect, useRef } from 'react'

export const useTimeout = () => {
  const timeoutRef = useRef<number | null>(null)

  const timeout = (callback: (...args: any[]) => any, timeout: number) => {
    timeoutRef.current = setTimeout(callback, timeout)
    return timeoutRef.current
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return timeout
}
